import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import ss from "./Await.module.css";
import Button from "../../components/Button";
import { useNavigate } from "react-router-dom";
import {
  apiRequest,
  showLoading,
  showAlert,
  API_SERVER_URL,
} from "../../utils";
import { Confirm } from "../../components/confirm/confirm";
import { GameModal } from "../../components/GameModal/GameModal";
import { QRCodeModalComponent } from "../../components/QRCodeModal/QRCodeModal";
import store from "../../store/store";

export default function Await() {
  const sessionUUID = new URLSearchParams(window.location.search).get(
    "session_uuid"
  );
  const navigate = useNavigate();
  const [teamList, setTeamList] = useState([]);
  // modal type: game_process, team_info, adjust_energy, failed_reason
  const gameModalType = useRef("");
  const [gameModalVisible, setGameModalVisible] = useState(false);
  // 是否开始讲解，未开始前只有“开始讲解按钮”高亮可点击，开始后【1级】【2级】【3级】【返回地图】【激活准备】【开始游戏】，这几个按键恢复可点击
  const [isExplainStart, setIsExplainStart] = useState(false);
  // 是否打开能量站，未打开前只有【打开-能量站】高亮可点击，打开后【关闭-能量站】高亮可点击
  const [isEnergyOpen, setIsEnergyOpen] = useState(false);
  // 1级：是否点击过 1 级，点击后任务判定按钮启用
  const [isTaskJudgeEnabled, setIsTaskJudgeEnabled] = useState(false);
  // 2级：是否点击过 2 级，点击后抢夺判定按钮启用
  const [isRobbingJudgeEnabled, setIsRobbingJudgeEnabled] = useState(false);
  // 3级：是否点击过 3 级，点击后能量站判定按钮启用
  const [isEnergyJudgeEnabled, setIsEnergyJudgeEnabled] = useState(false);
  // 是否已经讲解过
  const [isExplained, setIsExplained] = useState(false);
  // 是否激活准备
  const [isActiveReady, setIsActiveReady] = useState(false);

  const getTeamList = () => {
    const loading = showLoading("加载中");
    apiRequest("/get_team_list", "GET", {
      session_uuid: sessionUUID,
    })
      .then((res) => {
        if (res.code === 0) {
          setTeamList(res.teams);
        } else {
          showAlert(res.msg);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => loading.hide());
  };

  const getSessionInfo = () => {
    // const loading = showLoading("加载中");
    apiRequest("/get_session_info", "GET", {
      session_uuid: sessionUUID,
    }).then((res) => {
      if (res.code === 0) {
        if (res.game_session.status === 50) {
          setIsActiveReady(true);
          setIsExplained(true);
        }
      } else {
        showAlert(res.msg);
      }
    });
    // .finally(() => loading.hide());
  };

  const startGame = () => {
    Confirm.show("请确认是否开始游戏？", () => {
      const loading = showLoading("加载中");
      apiRequest("/start_game_session", "POST", {
        session_uuid: sessionUUID,
      })
        .then((res) => {
          if (res.code === 0) {
            apiRequest("/guide_back_map", "GET", {
              session_uuid: sessionUUID,
            }).then(() => {
              navigate(`/Backstage?session_uuid=${sessionUUID}`);
            });
          } else {
            showAlert(res.msg);
          }
        })
        .catch((err) => console.log(err))
        .finally(() => loading.hide());
    });
  };

  const activeReady = () => {
    Confirm.show("请确认是否激活准备？", () => {
      const loading = showLoading("加载中");
      apiRequest("/player_active_ready", "POST", {
        session_uuid: sessionUUID,
      })
        .then((res) => {
          if (res.code === 0) {
            showAlert("激活准备成功！");
            setIsActiveReady(true);
            apiRequest("/guide_back_map", "GET", { session_uuid: sessionUUID });
          } else {
            showAlert(res.msg);
          }
        })
        .catch((err) => console.log(err))
        .finally(() => loading.hide());
    });
  };

  useEffect(() => {
    store.dispatch.gameSession.setSessionUUID(sessionUUID);
    getTeamList();
    getSessionInfo();

    // 建立SSE连接
    let eventSource = new EventSource(
      `${API_SERVER_URL}/subscribe_messages?device_id=${sessionUUID}`
    );
    // 监听消息
    const onMessage = (event) => {
      const message = JSON.parse(event.data);
      console.log("收到消息:", message);
      // 处理连接成功消息
      if (message.type === "connected") {
        console.log("SSE连接成功");
        return;
      } else if (message.type === "player_join") {
        getTeamList();
      }
    };
    // 连接建立时的回调
    eventSource.onopen = () => {
      console.log("SSE连接已建立");
    };
    eventSource.onmessage = onMessage;
    // 错误处理
    eventSource.onerror = (error) => {
      console.error("SSE错误:", error);
      eventSource.close();

      // 3s后尝试重连
      setTimeout(() => {
        // Create a new EventSource connection
        eventSource = new EventSource(
          `${API_SERVER_URL}/subscribe_messages?device_id=${sessionUUID}`
        );
        // Re-attach event handlers
        eventSource.onmessage = onMessage;
      }, 3000);
    };
    // 在组件卸载时关闭连接
    return () => {
      if (eventSource) {
        eventSource.close();
        eventSource = null;
      }
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className={ss.bg}>
      <div className={ss.top}>
        <div
          className={ss.quit}
          onClick={() => {
            navigate(`/prepare?session_uuid=${sessionUUID}`);
          }}
        ></div>
        <Button
          title={"照片列表"}
          onClick={() => {
            navigate(`/photos?session_uuid=${sessionUUID}`);
            // Confirm.show("请确认是否关闭场次", () => {
            //   const loading = showLoading("加载中");
            //   apiRequest("/close_game_session", "POST", {
            //     session_uuid: sessionUUID,
            //   })
            //     .then((res) => {
            //       if (res.code === 0) {
            //         showAlert("关闭场次成功");
            //       } else {
            //         showAlert(res.msg);
            //       }
            //     })
            //     .catch((err) => console.log(err))
            //     .finally(() => loading.hide());
            // });
          }}
        />
        <Button
          title={"调整能量值"}
          onClick={() => {
            gameModalType.current = "change_energy";
            setGameModalVisible(true);
          }}
        />
        <Button
          title={"队伍信息"}
          onClick={() => {
            gameModalType.current = "team_info";
            setGameModalVisible(true);
          }}
        />
        <Button
          title={"游戏流程"}
          onClick={() => {
            gameModalType.current = "game_process";
            setGameModalVisible(true);
          }}
        />
      </div>
      <div className={ss.contentRows}>
        <div className={ss.player_Box}>
          {teamList.map((item, index) => {
            return (
              <div className={ss.team_box} key={index}>
                <img
                  src={require(`../../components/Avatar/img/color${item.color}.png`)}
                  alt=""
                />
                <div className={ss.team_play}>
                  已加入{item.number_of_players}人
                </div>
              </div>
            );
          })}
        </div>
        <div className={ss.btnRow}>
          <div
            className={classNames(
              ss.btnLong,
              isExplainStart && ss.gray,
              isActiveReady && ss.gray
            )}
            onClick={() => {
              Confirm.show("请确认是否开始讲解规则", () => {
                setIsExplainStart(true);
                setIsExplained(true);
                apiRequest("/start_guide", "GET", {
                  session_uuid: sessionUUID,
                });
              });
            }}
          >
            开始讲解规则
          </div>
        </div>
        <div className={ss.btnRow}>
          <div
            className={classNames(
              ss.rowBtn,
              !isExplainStart && ss.gray,
              isActiveReady && ss.gray
            )}
            onClick={() => {
              setIsTaskJudgeEnabled(true);
              apiRequest("/start_guide_level", "GET", {
                session_uuid: sessionUUID,
                level: 1,
              });
              // apiRequest("/start_guide_judge", "GET", {
              //   session_uuid: sessionUUID,
              //   level: 1,
              // });
            }}
          >
            1级
          </div>
          <div
            className={classNames(
              ss.rowBtn,
              !isExplainStart && ss.gray,
              isActiveReady && ss.gray
            )}
            onClick={() => {
              setIsRobbingJudgeEnabled(true);
              apiRequest("/start_guide_level", "GET", {
                session_uuid: sessionUUID,
                level: 2,
              });
              // apiRequest("/start_guide_judge", "GET", {
              //   session_uuid: sessionUUID,
              //   level: 2,
              // });
            }}
          >
            2级
          </div>
          <div
            className={classNames(
              ss.rowBtn,
              !isExplainStart && ss.gray,
              isActiveReady && ss.gray
            )}
            onClick={() => {
              setIsEnergyJudgeEnabled(true);
              apiRequest("/start_guide_level", "GET", {
                session_uuid: sessionUUID,
                level: 3,
              });
              // apiRequest("/start_guide_judge", "GET", {
              //   session_uuid: sessionUUID,
              //   level: 3,
              // });
            }}
          >
            3级
          </div>
          <div
            className={classNames(
              ss.rowBtn,
              !isExplainStart && ss.gray,
              isActiveReady && ss.gray
            )}
            onClick={() => {
              setIsEnergyJudgeEnabled(true);
              apiRequest("/start_guide_level", "GET", {
                session_uuid: sessionUUID,
                level: 11, // 随机补给
              });
              // apiRequest("/start_guide_judge", "GET", {
              //   session_uuid: sessionUUID,
              //   level: 3,
              // });
            }}
          >
            随机补给
          </div>
        </div>
        {/* <div className={ss.btnRow}>
          <div
            className={classNames(
              ss.rowBtn,
              !isExplainStart && ss.gray,
              isActiveReady && ss.gray
            )}
            onClick={() => {
              setIsTaskJudgeEnabled(true);
              apiRequest("/start_guide_level", "GET", {
                session_uuid: sessionUUID,
                level: 1,
              });
            }}
          >
            1级
          </div>
          <div
            className={classNames(
              ss.rowBtn,
              (!isExplainStart || !isTaskJudgeEnabled) && ss.gray,
              isActiveReady && ss.gray
            )}
            onClick={() => {
              apiRequest("/start_guide_judge", "GET", {
                session_uuid: sessionUUID,
                level: 1,
              });
            }}
          >
            任务判定
          </div>
          <div
            className={classNames(
              ss.rowBtn,
              !isExplainStart && ss.gray,
              isActiveReady && ss.gray
            )}
            onClick={() => {
              setIsRobbingJudgeEnabled(true);
              apiRequest("/start_guide_level", "GET", {
                session_uuid: sessionUUID,
                level: 2,
              });
            }}
          >
            2级
          </div>
          <div
            className={classNames(
              ss.rowBtn,
              (!isExplainStart || !isRobbingJudgeEnabled) && ss.gray,
              isActiveReady && ss.gray
            )}
            onClick={() => {
              apiRequest("/start_guide_judge", "GET", {
                session_uuid: sessionUUID,
                level: 2,
              });
            }}
          >
            抢夺判定
          </div>
        </div>
        <div className={ss.btnRow}>
          <div
            className={classNames(
              ss.rowBtn,
              !isExplainStart && ss.gray,
              isActiveReady && ss.gray
            )}
            onClick={() => {
              setIsEnergyJudgeEnabled(true);
              apiRequest("/start_guide_level", "GET", {
                session_uuid: sessionUUID,
                level: 3,
              });
            }}
          >
            3级
          </div>
          <div
            className={classNames(
              ss.rowBtn,
              (!isExplainStart || !isEnergyJudgeEnabled) && ss.gray,
              isActiveReady && ss.gray
            )}
            onClick={() => {
              apiRequest("/start_guide_judge", "GET", {
                session_uuid: sessionUUID,
                level: 3,
              });
            }}
          >
            能量站判定
          </div>
          <div
            className={classNames(
              ss.rowBtn,
              (!isExplainStart || !isEnergyJudgeEnabled || isEnergyOpen) &&
                ss.gray,
              isActiveReady && ss.gray
            )}
            onClick={() => {
              setIsEnergyOpen(true);
              apiRequest("/guide_open_hub", "GET", {
                session_uuid: sessionUUID,
                open: 1,
              });
            }}
          >
            打开-能量站
          </div>
          <div
            className={classNames(
              ss.rowBtn,
              (!isExplainStart || !isEnergyJudgeEnabled || !isEnergyOpen) &&
                ss.gray,
              isActiveReady && ss.gray
            )}
            onClick={() => {
              setIsEnergyOpen(false);
              apiRequest("/guide_open_hub", "GET", {
                session_uuid: sessionUUID,
                open: 0,
              });
            }}
          >
            关闭-能量站
          </div>
        </div> */}
        <div className={ss.btnRow}>
          <div
            className={classNames(
              ss.rowBtn,
              !isExplainStart && !isExplained && ss.gray,
              isActiveReady && ss.gray
            )}
            onClick={() => {
              setIsExplainStart(false);
              apiRequest("/guide_back_map", "GET", {
                session_uuid: sessionUUID,
              });
            }}
          >
            返回地图
          </div>
          <div
            className={classNames(
              ss.rowBtn,
              !isExplainStart && !isExplained && ss.gray,
              isActiveReady && ss.gray
            )}
            onClick={activeReady}
          >
            激活准备
          </div>
          <div
            className={classNames(
              ss.rowBtn,
              !isExplainStart && !isExplained && ss.gray
            )}
            onClick={startGame}
          >
            开始游戏
          </div>
        </div>
        <div style={{ height: "0.8rem" }}></div>
      </div>

      <GameModal
        visible={gameModalVisible}
        type={gameModalType.current}
        onClose={() => setGameModalVisible(false)}
        onConfirm={(value) => {
          if (gameModalType.current === "change_energy") {
            console.log(value);
            const loading = showLoading("加载中");
            apiRequest("/adjust_team_energy", "POST", {
              tid: value.teamUUID,
              type: value.changeType,
              energy: value.energyNum,
            })
              .then((res) => {
                if (res.code === 0) {
                  showAlert("调整能量值成功");
                } else {
                  showAlert(res.msg);
                }
              })
              .catch((err) => showAlert("请求失败，请稍后重试", err.message))
              .finally(() => {
                loading.hide();
              });
          }
        }}
      />
      <QRCodeModalComponent />
    </div>
  );
}
